import { useUserStore } from '@/shared/stores/user'
import { minutesToHours, secondsToMinutes } from 'date-fns'
import { format, formatInTimeZone } from 'date-fns-tz'

interface FormatTimestampOptionalArgs {
  formatString?: string
  forceLocalTimezone?: boolean
}

export const formatTimestamp = (
  timestamp: number,
  optionalArgs?: FormatTimestampOptionalArgs
) => {
  if (!timestamp) return null

  const userStore = useUserStore()

  const dateFormat = userStore.user?.dateFormat
    ? userStore.user.dateFormat
    : 'M/d/yyyy'

  const formatPattern = optionalArgs?.formatString || `${dateFormat} h:mm aaa`

  const timezone = optionalArgs?.forceLocalTimezone
    ? null
    : userStore.user?.timezone

  if (timezone) {
    return formatInTimeZone(timestamp, timezone.name, formatPattern)
  } else {
    return format(new Date(timestamp), formatPattern)
  }
}

export const formatTimeLeft = (timeLeft: number) => {
  if (timeLeft < 60) {
    return `${timeLeft} sec left`
  }

  const minutes = secondsToMinutes(timeLeft)

  if (minutes >= 60) {
    const remainingMinutes = minutes % 60
    const hours = minutesToHours(minutes)
    const hourAbbr = hours > 1 ? 'hrs' : 'hr'

    return `${hours} ${hourAbbr} ${remainingMinutes} min left`
  }

  return `${minutes} min left`
}

const formatClockTime = (seconds: number) => {
  const total = Math.max(0, Math.floor(seconds))
  const parts = [total / 3600, (total % 3600) / 60, total % 60]

  return parts
    .map((part) => String(Math.floor(part)).padStart(2, '0'))
    .join(':')
}

export const formatClockRange = (start: number, end: number) =>
  `${formatClockTime(start)} - ${formatClockTime(end)}`
